
import React, { Component } from 'react';
import { Button, ButtonToolbar, Tabs, Tab ,Row,Col,FormControl,FormGroup,Label,HelpBlock,ControlLabel} from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import { Checkbox } from 'react-icheck'
import moment from 'moment'
import WorkJobAssignTaskModal from '../jobcontrol/WorkJobAssignTaskModal'
import WorkdocStore from '../../../stores/WorkdocStore'
import RecheckTimeTable from '../recheckcontrol/RecheckTimeTable'
import IframeModal from '../../../component/element/IframeModal'
import FormJsonSchema from "react-jsonschema-form";
import LayoutField from "react-jsonschema-form-layout";
import {  moneyFormatter } from '../../../utils/helpers'

class RecheckEdit extends Component {

  constructor(...args) {
    super(...args)
    this.state = { data: {}, dataList: [], activeTab: 0,showField:false, showAssign: false,totalAmt: 0, totalCost: 0, totalDuration: 0, indexClick: -1, jobClick: -1, workState: [] }
  }

  loadWorkJob(item,workState) {
    if (!this.props.show) return
    
    this.setState({ data: item, workState: workState }, () => {
      this.refs.jobTime.loadData(item.work_no,item,workState)  
    })
    //Loading
  }

  loadWorkDataList(workNo) {
    let that = this
    this.setState({ loading: true})
    WorkdocStore.loadWorkdocFixingListWithTask(workNo, function (result) {
      let totalAmt = 0, totalCost = 0;
      let minStartDate = null;
      let maxEndDate = null;
      let data = result.data.map((item, index) => {
        totalAmt += item.wage_cost * 1
        if (item.tasklist !== undefined && item.tasklist !== null) {
          item.tasklist = item.tasklist.map((titem, tindex) => {
            totalCost += titem.totalCost * 1
            titem.tasklist.map((ditem, dindex) => {
              let startDate = moment(ditem.startDate, "DD/MM/YYYY")
              let endDate = moment(ditem.endDate, "DD/MM/YYYY")
              if (!minStartDate || minStartDate.isAfter(startDate)) {
                minStartDate = startDate
              }
              if (!maxEndDate || maxEndDate.isBefore(endDate)) {
                maxEndDate = endDate
              }

              return ditem
            })

            return {
              bf_task_id: titem.bf_task_id, totalCost: titem.total_cost, data: titem.tasklist
              , person: { contractor_id: titem.contractor_id, first_name: titem.first_name, nick_name: titem.nick_name, last_name: titem.last_name }
            }

            //return titem
          })
        }
        return item
      })
      
      let totalDuration = (maxEndDate && minStartDate) ? moment.duration(maxEndDate.diff(minStartDate)).asDays() + 1 : 0;
      that.setState({ loading: false, dataList: data, totalAmt: totalAmt, totalCost: totalCost, totalDuration: totalDuration })
    }, function () {
      that.setState({loading:false})
    })
  }


  onBackClick() {
    this.props.onClose()
  }

  onAssignClick(item, index) {
    let { dataList } = this.state
    this.setState({ showAssign: true, indexClick: index })
    this.refs.taskModal.loadTask(dataList[index])
  }



  onTaskDelete(tasklist) {
    let { dataList, indexClick, jobClick } = this.state
    let that = this

    // let job = dataList[indexClick].tasklist[jobClick]
    // console.log('deleteJob',dataList[indexClick].tasklist[jobClick])
    WorkdocStore.delWorkdocFixingTask(tasklist.bf_task_id, function () {
      dataList[indexClick].tasklist.splice(jobClick, 1)
      that.setState({ dataList: dataList, jobClick: -1 })  
    }, function () {

    })
  }

  onTaskSave(jobData) {
    let { data, dataList, indexClick, jobClick } = this.state
    if (dataList[indexClick].tasklist === undefined || dataList[indexClick].tasklist == null)
      dataList[indexClick].tasklist = []

    if (jobClick >= 0) {
      dataList[indexClick].tasklist[jobClick] = jobData
    } else {
      dataList[indexClick].tasklist.push(jobData)
    }

    let meta = { work_no: data.work_no, contractor_id: jobData.person.contractor_id, employee_id: '', total_cost: jobData.totalCost, bf_work_damage_id: dataList[indexClick].bf_work_damage_id }
    let postData = { meta: meta, tasklist: jobData.data }
    let that = this
    WorkdocStore.saveWorkdocFixingTask(jobData.bf_task_id, postData, function (result) {
      that.setState({ dataList: dataList, jobClick: -1 })
      if (that.props.onStateChange !== undefined)
        that.props.onStateChange(data.work_no, result.taskstate)
    }, function () {

    })

  }

  onJobEdit(rowIndex, index) {
    let { dataList } = this.state
    let tasklist = dataList[rowIndex].tasklist[index]

    this.setState({ showAssign: true, indexClick: rowIndex, jobClick: index })
    this.refs.taskModal.loadTask(dataList[rowIndex], tasklist)
  }

  onTabSelect(eventKey) {
    let { data } = this.state
    this.setState({ activeTab: eventKey })
    if (eventKey === '2') {
      //this.loadWorkDataList(data.work_no)
      
    }
  }

  onInputFocused(fieldInfo){
    this.refs.textFieldModal.loadInfo(fieldInfo)
    //this.setState({showField:true,fieldInfo:fieldInfo})
  }

  onPrintClick(){
    let {activeTab} = this.state
    let url = ''
    if (activeTab==2) {
      if (process.env.NODE_ENV == "development") {
        url  = './?startPage=PrintFixingOrderDoc'
      } else {
        url = ''
      }
    }  
    this.refs.iframePrint.loadUrl(url)
  }

  onFormChange(){

  }

  renderDuration(item) {
    if (item.taskStatus !== 2) {
      if (item.duration > 0)
        return (
          <span>ทำ {item.duration} วัน กำหนดเสร็จ {item.endDate}</span>
        )
      else {
        return (<span>ไม่กำหนดวัน</span>)
      }
    } else {
      return (<span />)
    }
  }

  renderTaskStatus(item) {
    if (item.taskStatus === '1') {
      return (<span><FontAwesome name='check-circle' className='text-green' />สถานะกำลังซ่อม</span>)
    } else if (item.taskStatus === '2') {
      return (<span><FontAwesome name='check-circle' className='text-blue' />สถานะซ่อมเสร็จแล้ว</span>)
    } else if (item.taskStatus === '3') {
      return (<span><FontAwesome name='check-circle' className='text-red' />สถานะหยุดชั่วขณะ</span>)
    } else {
      return (<span />)
    }
  }

  renderDetail(detail) {
    if (detail === undefined || !detail) {
      detail = ''
    }
    return (<span>{detail}</span>)
  }

  renderJobList(rowIndex, tasklist) {
    // console.log('tasklist', tasklist)
    if (tasklist !== undefined && tasklist !== null) {
      return tasklist.map((jitem, jindex) => (
        <div key={jindex}>
          <h4><b><Button bsStyle='link' onClick={this.onJobEdit.bind(this, rowIndex, jindex)}>
            {jitem.person.first_name} <FontAwesome name='pencil' /></Button></b>
            ราคาเหมา {moneyFormatter.format(jitem.totalCost)} บาท
          </h4>
          {jitem.data.map((item, index) => (
            <div key={index}>{item.taskName} {this.renderDetail(item.detail)} {this.renderTaskStatus(item)} {this.renderDuration(item)} </div>
          ))}
        </div>
      )
      )
    } else {
      return (<div />)
    }
  }

  renderRowData() {
    let { dataList } = this.state
    return dataList.map((item, index) => (
      <tr key={index}>
        <td className='text-center'>
          {index + 1}
        </td>
        <td>
          {item.detail}
        </td>
        <td className='text-center'>
          <Checkbox
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            checked={item.paint_flag === '1'}
            readOnly
          />
        </td>
        <td className='text-center' >
          <Checkbox
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            checked={item.fix_flag === '1'}
            readOnly
          />
        </td>
        <td className='text-center' >
          <Checkbox
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            checked={item.part_flag === '1' || item.stock_flag === '1'}
            readOnly
          />
        </td>
        <td className='text-right'>{item.wage_cost}</td>
        <td>
          <Button bsStyle='primary' onClick={this.onAssignClick.bind(this, item, index)}><FontAwesome name='plus' />&nbsp;ใส่ผู้รับผิดชอบ</Button>
          {this.renderJobList(index, item.tasklist)}
        </td>
      </tr>
    ))
  }

  renderTable() {
    let { totalAmt, totalCost, totalDuration } = this.state
    totalAmt = moneyFormatter.format(totalAmt)
    totalCost = moneyFormatter.format(totalCost)
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr>
            <th className='text-center' style={{ width: '30px' }}>ลำดับ</th>
            <th>รายการงานซ่อม</th>
            <th className='text-center' style={{ width: '35px' }}>เคาะ-พ่นสี</th>
            <th className='text-center' style={{ width: '30px' }}>ซ่อม</th>
            <th className='text-center' style={{ width: '30px' }}>เปลี่ยน</th>
            <th className='text-center' style={{ width: '100px' }}>ค่าแรงอนุมัติ</th>
            <th className='text-center' style={{ width: '400px' }}>ช่างซ่อม</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          <tr>
            <th className='text-right' colSpan={5}>รวมค่าแรง</th>
            <th className='text-right'>{totalAmt}</th>
            <th className='text-right'>รวมระยะเวลา {totalDuration} วัน ค่าช่างเหมา {totalCost} บาท</th>
          </tr>
        </tfoot>
      </table>
    )
  }

  renderButton() {
    return (
      <ButtonToolbar className='pull-right'>

        <Button onClick={this.onBackClick.bind(this)}><FontAwesome name='close' />&nbsp;กลับไปยังตาราง</Button>
      </ButtonToolbar>
    )
  }

  renderSummary(){
    const schema = {
      title: "โดยสรุป",
      type: "object",      
      properties: {
        total_cost_amount: {type: "string", title: "ต้นทุนค่าแรง"},
        total_wage_approve: {type: "string", title: "ค่าแรงอนุมัติ"},
        profit_amount: {type: "string", title: "กำไร"},        
      }
    }
    const uiSchema = {
      'ui:field': 'layout',
      'ui:layout': [
        { 
          total_cost_amount:{md:3},
          total_wage_approve:{md:3},
          profit_amount:{md:3}
        }              
      ]   
    }
        
    return (
      <FormJsonSchema 
        schema={schema}
        uiSchema={uiSchema}
        fields={{layout: LayoutField}}
        formData=""               
        onChange={this.onFormChange.bind(this)}
      >
        
    </FormJsonSchema>
    )
  }

  renderSummary2(){
    
    return (
      <div>
        <Row>
          <Col md={3}>
              <FormGroup
              controlId="formBasicText"              
            >
              <ControlLabel>ต้นทุนค่าแรง</ControlLabel>
              <FormControl
                type="text"
                value={'5000'}   
                                           
              />
              <FormControl.Feedback />              
            </FormGroup>
          </Col>
          <Col md={3}>
              <FormGroup
                controlId="formBasicText"              
              >
                <ControlLabel>ค่าแรงอนุมัติ</ControlLabel>
                <FormControl
                  type="text"
                  value={'6000'}     
                                            
                />
                <FormControl.Feedback />              
              </FormGroup>
          </Col>
          <Col md={3}>
              <FormGroup
                controlId="formBasicText"              
              >
                <ControlLabel>กำไรเบื้องต้น</ControlLabel>
                <FormControl
                  type="text"
                  value={'6000'}    
                                             
                />
                <FormControl.Feedback />              
              </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>          
              <FormGroup
                controlId="formBasicText"              
              >
                <ControlLabel>รายละเอียดอื่นๆ</ControlLabel>
                <FormControl
                  componentClass="textarea" 
                  placeholder="ใส่รายละเอียดงาน"
                  value={''}          
                 
                />
                <FormControl.Feedback />              
              </FormGroup>          
          </Col>
        </Row>
        
      </div>
    )
  }

  renderTab(titleTask) {
    let {control} = this.props
    return (
      <Tabs defaultActiveKey="0" animation={false} id="noanim-tab-example" onSelect={this.onTabSelect.bind(this)}>
        <Tab eventKey="0"
          title={(<div><FontAwesome name="tasks"/> สถานะงานภายในออฟฟิศ </div>)}>
          <RecheckTimeTable 
              ref='jobTime'
              workState={this.state.workState}
              jobStyle={this.props.jobStyle}
              jobState={this.props.jobState}
              onStateChange={this.props.onStateChange} />
        </Tab>
      </Tabs>
    )
  }

  render() {
    if (!this.props.show) return null
    let { show } = this.props
    let { data, dataList, showAssign, indexClick } = this.state
    let title = 'รายการงานซ่อม ' + data.work_no + ' ทะเบียน ' + data.car_registration_no + ' รถ/รุ่น ' + data.car_detail

    let titleTask = (indexClick >= 0) ? dataList[indexClick].detail + ' ค่าแรงอนุมัติ ' + dataList[indexClick].wage_cost : ''
    return (
      <div style={{ display: (show) ? 'block' : 'none' }}>
        <Box loading={this.state.loading}>
          <Box.Header border={true}>
            <Box.Title>{title}</Box.Title>
            
          </Box.Header>
          <Box.Body>
            {this.renderTab(titleTask)}
            <WorkJobAssignTaskModal ref='taskModal' show={showAssign} title={titleTask}
              onDelete={this.onTaskDelete.bind(this)}
              onSave={this.onTaskSave.bind(this)}
              onHide={() => { this.setState({ showAssign: false }) }} />
          </Box.Body>
          <Box.Footer>
            {this.renderButton()}
          </Box.Footer>
          <IframeModal ref='iframePrint' title='พิมพ์เอกสาร'/>
        </Box>
      </div>
    )
  }
}

RecheckEdit.defaultProps = {
  control: 'workJobOffice'
}

export default RecheckEdit;





// WEBPACK FOOTER //
// ./src/view/workdoc/recheckcontrol/RecheckEdit.js